import { useState } from 'react'
import { Link } from 'react-router-dom'
import AddGameModal from '@/components/AddGameModal/AddGameModal'
import supabase from '@/supabaseClient'

interface OnboardingFlowProps {
  onComplete: () => void
  userName?: string
}

const OnboardingFlow: React.FC<OnboardingFlowProps> = ({ onComplete, userName }) => {
  const [showAddGame, setShowAddGame] = useState(false)

  const handleGameAdded = async () => {
    setShowAddGame(false)
    const { data: games, error } = await supabase
      .from('games')
      .select('id')
      .limit(1)

    if (!error && games && games.length > 0) {
      onComplete()
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-base-100">
      <div className="max-w-lg w-full px-6 py-16 text-center">
        <h1 className="text-4xl font-bold font-serif mb-4" style={{ color: '#3d2a1e' }}>
          Hey{userName ? `, ${userName}` : ''}.
        </h1>
        <p className="text-xl font-serif mb-6" style={{ color: '#6b5344', fontStyle: 'italic' }}>
          Let's see what you've been sitting on.
        </p>
        <p className="text-base mb-10" style={{ color: '#6b5344' }}>
          Start with one game. Something you've been meaning to play — even something you bought on sale and forgot about.
        </p>

        <button
          className="btn btn-primary rounded-full px-10 mb-6"
          onClick={() => setShowAddGame(true)}
        >
          + Add a game
        </button>

        <p className="text-sm" style={{ color: '#a68565' }}>
          or{' '}
          <Link
            to="/app/profile"
            className="underline underline-offset-2 hover:opacity-70 transition-opacity"
            onClick={onComplete}
          >
            connect your Steam library
          </Link>
          {' '}to import everything at once
        </p>

        <p className="text-xs mt-16" style={{ color: '#c4a882' }}>
          Backlog Explorer is in beta. Things may change — feedback always welcome.
        </p>
      </div>

      {showAddGame && (
        <AddGameModal
          onGameAdded={handleGameAdded}
          showModal={showAddGame}
          setShowModal={setShowAddGame}
        />
      )}
    </div>
  )
}

export default OnboardingFlow
